import React from 'react'
import { string, func } from 'prop-types'
import styled from 'styled-components'

const Container = styled.span`
  cursor: pointer;
`

const OnClickableLink = ({ onClick, to, label, ...rest }) => {
  return (
    <Container {...rest}>
      <a onClick={onClick} to={to}>
        {label}
      </a>
    </Container>
  )
}

OnClickableLink.propTypes = {
  to: string,
  label: string,
  onClick: func,
  display: string
}

export { OnClickableLink }
